import { importDependency } from 'core-components/helpers'
import { IAppStoreRemoteReducers } from 'src/core/components/app/models/IAppStore'

import ariaReducer from './ariaSlice'

export const ariaProjectReducer = {
  aria: ariaReducer,
}

export const ariaRemoteReducers: IAppStoreRemoteReducers[] = [
  {
    key: 'remoteKbase',
    initReducer: async () => {
      return importDependency(
        'remoteKbase/kbaseReducer',
        () => import('remoteKbase/kbaseReducer'),
        (data) => {
          return data.reducer
        }
      )
    },
  },
  {
    key: 'remoteDocflow',
    initReducer: async () => {
      return importDependency(
        'remoteDocflow/docflowReducer',
        () => import('remoteDocflow/docflowReducer'),
        (data) => {
          return data.reducer
        }
      )
    },
  },
]
